<app-header *ngIf="isLoggedIn()"></app-header>

<div class="main-content">
  <router-outlet></router-outlet>
</div>

<app-footer *ngIf="isLoggedIn()"></app-footer>
